// React Query hooks for audit logs.

import { useQuery } from '@tanstack/react-query';
import { listAuditLogs, type ListAuditLogsOptions } from '@/lib/api/auditLogs';

const KEYS = {
  all: ['audit-logs'] as const,
  list: (options: ListAuditLogsOptions) => [...KEYS.all, 'list', options] as const,
};

export const useAuditLogs = (options: ListAuditLogsOptions = {}) =>
  useQuery({
    queryKey: KEYS.list(options),
    queryFn: () => listAuditLogs(options),
    // Audit logs are not real-time critical — 30s staleness is fine.
    staleTime: 30 * 1000,
  });

export const auditLogKeys = KEYS;
